export default "__VITE_ASSET__B5ktcy8F__"